var map = {
	"./d-adreno.json": 622,
	"./d-amd.json": 183,
	"./d-apple.json": 732,
	"./d-geforce.json": 405,
	"./d-intel.json": 178,
	"./d-nvidia.json": 217,
	"./d-radeon.json": 145,
	"./m-adreno.json": 921,
	"./m-apple-ipad.json": 535,
	"./m-apple.json": 438,
	"./m-intel.json": 283,
	"./m-mali-t.json": 327,
	"./m-mali.json": 538,
	"./m-nvidia.json": 884,
	"./m-powervr.json": 214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 804;